import { CheckIcon, CloseIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
  Button,
  Flex,
  HStack,
  IconButton,
  Input,
  Select,
  Table, Tbody,
  Td,
  Th, Thead, Tr,
  VStack,
  Checkbox,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Tag,
  useToast // Importe o hook useToast
} from '@chakra-ui/react';
import { PackageSearch } from 'lucide-react'
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { TagsInput } from 'components/TagsInput';
import RepositoriesController from "controllers/Repositories/RepositoriesController";
import { useEffect, useState } from 'react';

function RepositoriesView() {
  const [data, setData] = useState([]);
  const [newRepoName, setNewRepoName] = useState("");
  const [newPromptName, setNewPromptName] = useState("");
  const [esterioOption, setEsterioOption] = useState("");
  const [esterioOptionSide, setEsterioOptionSide] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedRepos, setSelectedRepos] = useState([]);
  const [fichasData, setFichasData] = useState([]);
  const [totalFichas, setTotalFichas] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const textColor = useColorModeValue("gray.700", "white");

  const [checkedFichas, setCheckedFichas] = useState([]);

  const toast = useToast(); // Inicialize o hook useToast

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await RepositoriesController.ListRepositorios();
        setData(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const addRepo = async () => {
    let esterioValue = null;
    let esterioOptionValue = null;

    if (esterioOption === "option1") {
      esterioValue = 1;
    } else if (esterioOption === "option2") {
      esterioValue = 2;
    }

    if (esterioOptionSide === "option1") {
      esterioOptionValue = 1;
    } else if (esterioOptionSide === "option2") {
      esterioOptionValue = 2;
    }

    try {
      if (esterioValue === null) {
        toast({
          title: "Erro",
          description: "Por favor, selecione se o repositório é estério ou não!",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      if (newRepoName === "") {
        toast({
          title: "Erro",
          description: "Por favor, adicione um nome ao repositório!",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const response = await RepositoriesController.AddRepositorios(newRepoName, esterioValue, esterioOptionValue, newPromptName);
      console.log(response);

      if (response) {
        const newRepo = await RepositoriesController.ListRepositorios();
        setData(newRepo);
        setNewRepoName("");
        setEsterioOption("");
        setEsterioOptionSide("");
        setNewPromptName("");
        toast({
          title: "Sucesso",
          description: "Repositório adicionado com sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error adding repo:", error);
      toast({
        title: "Erro",
        description: "Erro ao adicionar o repositório",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleModalCheckboxChange = (id) => {
    if (!checkedFichas.includes(id)) {
      setCheckedFichas((prev) => [...prev, id])
    } else {
      setCheckedFichas((prev) => prev.filter((num) => num !== id))
    }
  };

  const handleTableCheckboxChange = async (event, repoId) => {
    if (event.target.checked) {
      setSelectedRepos(prev => [...prev, repoId]);
      try {
        const response = await RepositoriesController.CountRepositoriosToReprocess([repoId]);
        if (response.status === 200) {
          const quantity = response.result.find(item => item.id_repos === repoId)?.quantity_repos || 0;
          setTotalFichas(prev => prev + quantity);
        } else {
          toast({
            title: "Erro",
            description: "Erro ao buscar quantidade de fichas",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (error) {
        console.error("Error fetching ficha count:", error);
        toast({
          title: "Erro",
          description: "Erro ao buscar quantidade de fichas",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } else {
      setSelectedRepos(prev => prev.filter(id => id !== repoId));

      try {
        const response = await RepositoriesController.CountRepositoriosToReprocess([repoId]);
        if (response.status === 200) {
          const quantity = response.result.find(item => item.id_repos === repoId)?.quantity_repos || 0;
          setTotalFichas(prev => prev - quantity);
        } else {
          toast({
            title: "Erro",
            description: "Erro ao buscar quantidade de fichas",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (error) {
        console.error("Error fetching ficha count:", error);
        toast({
          title: "Erro",
          description: "Erro ao buscar quantidade de fichas",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    }
  };

  const handleFetchFichas = async () => {
    try {
      const response = await RepositoriesController.ListRepositoriosToReprocess(selectedRepos, startDate, endDate);
      if (response.status === 200) {
        setFichasData(response.result);
        onOpen();
      } else {
        toast({
          title: "Erro",
          description: "Erro ao buscar fichas",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error fetching fichas:", error);
      toast({
        title: "Erro",
        description: "Erro ao buscar fichas",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleApplyFichas = async () => {
    try {
      const response = await RepositoriesController.ReprocessRepos(selectedRepos, checkedFichas);
      if (response.status === 200) {
        toast({
          title: "Sucesso",
          description: "Fichas aplicadas com sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        onClose();
      } else {
        toast({
          title: "Erro",
          description: "Erro ao aplicar fichas",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error applying fichas:", error);
      toast({
        title: "Erro",
        description: "Erro ao aplicar fichas",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex direction='column' height={'100%'} width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader>
          <VStack spacing={2} align="stretch">
            <HStack spacing={2}>
              <h6>Você selecionou: {totalFichas}</h6>
            </HStack>
            <HStack spacing={2}>
              <Input
                type="date"
                name="start_date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
              <Input
                type="date"
                name="end_date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
              />
              <Button colorScheme="blue" width="auto" minWidth="200px" onClick={handleFetchFichas}>Fichas</Button>
            </HStack>
            <HStack spacing={2}>
              <Input
                placeholder="Nome"
                name="nome"
                value={newRepoName}
                onChange={e => setNewRepoName(e.target.value)}
              />
              <Input
                placeholder="HotWords"
                name="prompt"
                value={newPromptName}
                onChange={e => setNewPromptName(e.target.value)}
              />
              <Select
                placeholder="Estéreo?"
                value={esterioOption}
                onChange={e => setEsterioOption(e.target.value)}
              >
                <option value="option1">Sim</option>
                <option value="option2">Não</option>
              </Select>
              <Select
                placeholder="Estéreo cliente"
                value={esterioOptionSide}
                onChange={e => setEsterioOptionSide(e.target.value)}
                isDisabled={esterioOption !== "option1"}
              >
                <option value="option1">Esquerdo</option>
                <option value="option2">Direito</option>
              </Select>
              <Button colorScheme="blue" width="auto" minWidth="200px" onClick={addRepo}>Adicionar</Button>
            </HStack>
          </VStack>
        </CardHeader>
        <CardBody>
          <Table variant='simple' color={textColor}>
            <Thead>
              <Tr color='gray.400'>
                <Th color={textColor}></Th>
                <Th color={textColor}>Nome</Th>
                <Th color={textColor}>Estéreo?</Th>
                <Th color={textColor}>Estéreo cliente</Th>
                <Th color={textColor}>HotWords</Th>
                <Th color={textColor}>Ações</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((repo) => (
                <RepoRow key={repo.id_repos} repo={repo} setData={setData} handleTableCheckboxChange={handleTableCheckboxChange} lineHeight="0.5"/>
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>

      <Modal isOpen={isOpen} onClose={onClose} style={{ width: "80%" }}>
        <ModalOverlay />
        <ModalContent minWidth="fit-content">
          <ModalHeader>Fichas</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table variant='simple' color={textColor} style={{ width: "80%" }}>
              <Thead>
                <Tr color='gray.400'>
                  <Th color={textColor}></Th>
                  <Th color={textColor}>ID da Ficha</Th>
                  <Th color={textColor}>Nome da Ficha</Th>
                  <Th color={textColor}>Nome da Operação</Th>
                </Tr>
              </Thead>
              <Tbody>
                {fichasData.map((ficha) => (
                  <Tr key={ficha.id}>
                    <Td>
                      <Checkbox
                        onChange={() => handleModalCheckboxChange(ficha.id)}
                      />
                    </Td>
                    <Td>{ficha.id}</Td>
                    <Td>{ficha.ficha_name}</Td>
                    <Td>{ficha.operation_name}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleApplyFichas}>
              Aplicar Fichas
            </Button>
            <Button variant="ghost" onClick={onClose}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

function RepoRow({ repo, setData, handleTableCheckboxChange }) {
  const repoPrompt = repo && repo.prompt && repo.prompt.split(' ')

  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(repo.reponame);
  const textColorForBorder = useColorModeValue("gray", "white");
  const textColorFont = useColorModeValue("white", "gray");

  const [tags, setTags] = useState(repoPrompt ?? [])

  const tagsJoin = tags && tags.length > 0 && tags.join(' ')

  const toast = useToast(); // Inicialize o hook useToast

  const editRepo = async () => {
    try {
      const response = await RepositoriesController.PutRepositorios(repo.id_repos, editedName, tagsJoin);
      if (response) {
        const updatedRepo = await RepositoriesController.ListRepositorios();
        setData(updatedRepo);
        setIsEditing(false);
        toast({
          title: "Sucesso",
          description: "Repositório editado com sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error editing repo:", error);
      toast({
        title: "Erro",
        description: "Erro ao editar o repositório",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const deleteRepo = async () => {
    try {
      const response = await RepositoriesController.DeleteRepositorios(repo.id_repos);
      if (response) {
        const updatedRepo = await RepositoriesController.ListRepositorios();
        setData(updatedRepo);
        toast({
          title: "Sucesso",
          description: "Repositório deletado com sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error deleting repo:", error);
      toast({
        title: "Erro",
        description: "Erro ao deletar o repositório",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const transcribeRepo = async () => {
    try {
      const response = await RepositoriesController.ReprocessReposJustTranscriptions([repo.id_repos]);
      if (response) {
        toast({
          description: "Processado com sucesso.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error deleting repo:", error);
      toast({
        title: "Erro",
        description: "Erro ao iniciar transcrição",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Tr>
      <Td><Checkbox onChange={(e) => handleTableCheckboxChange(e, repo.id_repos)} /></Td>
      <Td>{isEditing ? <Input value={editedName} onChange={e => setEditedName(e.target.value)} /> : repo.reponame}</Td>
      <Td>{repo.esterio}</Td>
      <Td>{repo.esterio_side}</Td>
      <Td maxW={450}>
        {isEditing ? (
          <TagsInput tags={tags} setTags={setTags} />
        ) : (
          <Flex flexDir={'row'} flexWrap={'wrap'} gap={1}>
            {repo && repo.prompt && repo.prompt.split(" ").map((word, index) => (
              <Tag key={index}>
                {word}
              </Tag>
            ))}
          </Flex>
        )}
      </Td>
      <Td>
        {isEditing ? (
          <nobr>
            <IconButton icon={<CheckIcon />} onClick={editRepo} mr={2} />
            <IconButton icon={<CloseIcon />} onClick={() => setIsEditing(false)} mr={2} />
          </nobr>
        ) : (
          <nobr>
            <IconButton icon={<PackageSearch />} onClick={transcribeRepo} mr={2} />
            <IconButton icon={<EditIcon />} onClick={() => setIsEditing(true)} mr={2} />
            <IconButton icon={<DeleteIcon />} onClick={deleteRepo} mr={2} />            
          </nobr>
        )}
      </Td>
    </Tr>
  );
}

export default RepositoriesView;
